import { apiClient, handleApiError } from './apiClient';
import { USERS_API_BASE_URL } from '../constants';

export interface AppUserSession {
  id: number;
  user_uuid: string;
  org_uuid: string | null;
  session_start: string;
  session_end: string | null;
  status: string;
  metadata: string | null;
  client_ip: string | null;
  client_device: string | null;
  user_type: string | null;
  session_timeout: string | null;
  userName: string | null;
  userEmail: string | null;
  usertype: string | null;
  isBlacklisted: boolean;
}

export interface AppUserSessionsResponse {
  status: number;
  data: AppUserSession[];
  total: number;
  page: number;
  pageSize: number;
}

export const getAppUserSessions = async (
  page: number,
  pageSize: number,
  search: string,
  sortOrder: 'asc' | 'desc',
  token: string
): Promise<AppUserSessionsResponse> => {
  try {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
      sortOrder,
    });
    if (search) params.set('search', search);

    const response = await apiClient.get(
      `${USERS_API_BASE_URL}/app-users/all?${params.toString()}`,
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

export const blacklistSession = async (
  sessionId: number,
  token: string
): Promise<{ status: number; msg: string }> => {
  try {
    const response = await apiClient.post(
      `${USERS_API_BASE_URL}/app-users/blacklist`,
      { sessionId },
      { headers: { Authorization: token } }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
